import { LatLngTuple } from "leaflet";
import {
  MapContainer,
  LayersControl,
  TileLayer,
  FeatureGroup,
} from "react-leaflet";
import React from "react";
import "leaflet/dist/leaflet.css";
import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
import "leaflet-extra-markers";
import BoundaryLeaflet from "./boundary-leaflet";
import Geospatial from "models/geospatial/geospatial";
import Boundary from "models/geospatial/boundary";
import Point from "models/geospatial/point";
import PointLeaflet from "./point-leaflet";
import { Box } from "@mui/material";

const position: LatLngTuple = [-27.5, 134];

// const ResizeHandler = () => {
//   const map = useMap();

//   useEffect(() => {
//     const handleResize = () => {
//       map.invalidateSize();
//     };

//     // Add a resize listener
//     window.addEventListener("resize", handleResize);

//     return () => {
//       // Clean up the listener
//       window.removeEventListener("resize", handleResize);
//     };
//   }, [map]);

//   return null;
// };

const MapLeaflet = ({ data }: { data: Geospatial }) => {
  return (
    <Box pt={2} style={{ height: "100%", minHeight: "400px", width: "100%" }}>
      <MapContainer
        style={{ height: "100%", minHeight: "400px", width: "100%" }}
        center={position}
        zoom={5}
        zoomAnimation={true}
      >
        {/* <ResizeHandler /> */}
        <LayersControl position="topleft">
          <LayersControl.BaseLayer checked name="Street">
            <TileLayer
              attribution="Google Maps"
              url="https://{s}.google.com/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer
              attribution="Google Maps"
              url="https://{s}.google.com/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Grayscale">
            <TileLayer
              id="mapbox/light-v9"
              attribution='Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFyaWNjaGVuIiwiYSI6ImNpd2NuazByczA1bTMyeXBvNG1iejByZDYifQ.cQJ6l4b68Y0kXgWB3HnF6w"
            />
          </LayersControl.BaseLayer>
        </LayersControl>
        <FeatureGroup>
          {"bbox" in data && <BoundaryLeaflet boundary={data as Boundary} />}
          {"latitude" in data && "longitude" in data && (
            <PointLeaflet point={data as Point} />
          )}
        </FeatureGroup>
      </MapContainer>
    </Box>
  );
};

export default MapLeaflet;
